import React from 'react';
import PropTypes from 'prop-types';
import { truncateFileName } from '@carvana/purchase-utils';
import { DocumentImage as _DocumentImage } from '@carvana/purchase-components';
import * as payStubWizardStyles from '../../document-wizard-modal.styles';
import * as documentPreviewStyles from './document-preview.styles';

const sc = { ...payStubWizardStyles, ...documentPreviewStyles };

const DocumentPreview = props => {
  const { document, showFileUploadForm } = props;
  const imageName = document?.image?.name
  const imageSrc = document?.image?.src
  const imageType = document?.image?.type

  const DocumentImage = _DocumentImage({
    image: {
      name: imageName,
      srcUrl: imageSrc,
      type: imageType
    }
  });

  return (
    <sc.DocumentPreviewWrapper>
      <sc.DocumentImageWrapper>{DocumentImage}</sc.DocumentImageWrapper>
      <sc.DocumentPreviewFooter>
        <sc.FullViewButton onClick={DocumentImage.props.openFullView}>
          Full View
        </sc.FullViewButton>
        <span css={sc.footerTextDividerStyles}>&#124;</span>
        <sc.FileName>{truncateFileName(imageName, 26)}</sc.FileName>
        <sc.ReuploadButton onClick={showFileUploadForm}>
          Re-Upload
        </sc.ReuploadButton>
      </sc.DocumentPreviewFooter>
    </sc.DocumentPreviewWrapper>
  );
};

DocumentPreview.propsTypes = {
  showFileUploadForm: PropTypes.func.isRequired
};

export default DocumentPreview;
